export default __webpack_public_path__ + "05ff1af67bf12f7f09227f23e5e0382d.svg";